import ConnectionUtil from "../../util/session/ConnectionUtil";

export default class Upload {
  constructor(uploading, file, emit, manager) {
    this.uploading = uploading;
    this.file = file;
    this.emit = emit;
    this.manager = manager;
    this.id = uploading.id;
    this.xhr = null;
    this.aborted = false;
    this.prefix = `[UploadWorker ${this.id}]`;
  }

  start() {
    const { id, prefix } = this;
    const url = ConnectionUtil.getPreviewServerUrl() + '/webclient/uploadFile?action=upload&uniqueKey=' + this.uploading.uniqueKey;
    const xhr = (this.xhr = new XMLHttpRequest());
    const formData = new FormData();
    formData.append('key', this.file);

    xhr.upload.onprogress = (e) => {
      const { loaded, total } = e;
      // console.log(`${prefix} upload progress ${loaded} of ${total}`);
      this.emit('UPLOAD_PROGRESS', { id, loaded, total });
    };

    xhr.upload.onerror = () => {
      // console.log(`${prefix} upload error`);
      this.emit('UPLOAD_ERROR', { id });
    };

    xhr.onreadystatechange = (e) => {
      if (this.aborted || e.target.readyState !== 4) {
        return;
      }

      this.manager.remove(this);
      // console.log(`${prefix} upload success`);
      this.emit('UPLOAD_SUCCESS', { id });
    };

    xhr.open('POST', url);
    xhr.send(formData);
  }

  stop() {
    if (this.xhr && this.xhr.readyState === 4) {
      return;
    }

    this.aborted = true;
    if (this.xhr) {
      this.xhr.abort();
    }

    this.manager.remove(this);
    this.emit('UPLOAD_ABORTED', { id: this.id });
    // console.log(`${this.prefix} upload aborted`);
  }

  readImage() {
    const { id, prefix, file } = this;
    const url = URL.createObjectURL(file);
    this.manager.addUrl(url);
    // console.log(`${prefix} image loaded`);
    this.emit('IMAGE_LOADED', { id, result: url });
  }

}
